module.exports = __webpack_public_path__ + "static/media/ionicons.37939349.ttf";